import React, { useState } from 'react'
import { Modal, Spin } from '@arco-design/web-react'
import Draggable from 'react-draggable'
export const LoongInCommonConfirm = ({
  children, //子内容，如果有则content失效。
  title, //标题
  content, //内容
  isVisible, //是否可见
  isLoading, //是否显示加载中
  onConfirm, //确认事件
  confirmText, //确认按钮标题
  onCancel, //取消事件
  cancelText, //取消按钮标题
  showCloseButton, //显示关闭按钮
  closeOnEscape, //按Esc关闭
  draggable = true, //可拖拽
  style = {},
}) => {
  const [draggableDisabled, setDraggableDisabled] = useState(true)
  return (
    <Modal
      style={style}
      title={title}
      visible={isVisible}
      onOk={onConfirm}
      onCancel={onCancel}
      autoFocus={false}
      focusLock={true}
      okText={confirmText}
      cancelText={cancelText}
      closable={showCloseButton}
      escToExit={closeOnEscape}
      confirmLoading={isLoading}
      onMouseOver={() => {
        draggable && draggableDisabled && setDraggableDisabled(false)
      }}
      onMouseOut={() => {
        draggable && !draggableDisabled && setDraggableDisabled(true)
      }}
      modalRender={
        draggable
          ? (modal) => (
              <Draggable disabled={draggableDisabled}>{modal}</Draggable>
            )
          : undefined
      }
    >
      {!isLoading && (children || <div>{content}</div>)}
      {isLoading && (
        <div style={{ height: 80, position: 'relative' }}>
          <div className="central-position">
            <Spin size={20} />
          </div>
        </div>
      )}
    </Modal>
  )
}
